"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUniverse = exports.SET_UNIVERSE_FAILURE = exports.SET_CURRENT_UNIVERSE = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _groupedPersona = require("../../groupedPersonas/groupedPersona");

var _loadGrouped = require("../findPersonas/loadGrouped");

var _loadIndividual = require("../findPersonas/loadIndividual");

var _loadPopulations = require("../populations/loadPopulations");

var _loadDigitalAudiencesVendors = require("../loadDigitalAudiencesVendors");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var SET_CURRENT_UNIVERSE = 'SET_CURRENT_UNIVERSE';
exports.SET_CURRENT_UNIVERSE = SET_CURRENT_UNIVERSE;
var SET_UNIVERSE_FAILURE = 'SET_UNIVERSE_FAILURE';
exports.SET_UNIVERSE_FAILURE = SET_UNIVERSE_FAILURE;

var setCurrentUniverse = function setCurrentUniverse(universe) {
  return {
    type: SET_CURRENT_UNIVERSE,
    payload: universe
  };
};

var setUniverseFailure = function setUniverseFailure(error) {
  return {
    type: SET_UNIVERSE_FAILURE,
    payload: error
  };
};

var setUniverse = function setUniverse(universeId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      var currentState, characteristics, selectedPersonas, vendors;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return dispatch(setCurrentUniverse(universeId));

            case 3:
              currentState = getState();
              characteristics = currentState.selectedCharacteristics.characteristics;
              selectedPersonas = currentState.selectedPersonas.personas;
              vendors = currentState.campaignCreator.digitalAudiencesVendors.vendors;

              if (characteristics) {
                dispatch((0, _loadGrouped.loadGrouped)());
                dispatch((0, _loadIndividual.loadIndividual)());
              }

              if (selectedPersonas) {
                dispatch((0, _groupedPersona.loadGroupedPersona)());
              }

              if (vendors.length > 0) {
                dispatch((0, _loadDigitalAudiencesVendors.loadDigitalAudiencesVendors)());
              }

              dispatch((0, _loadPopulations.loadPopulations)());
              _context.next = 18;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              dispatch(setUniverseFailure(_context.t0));

              if (process.env.NODE_ENV !== 'test') {
                Sentry.captureException(_context.t0);
                console.error(_context.t0);
              }

              return _context.abrupt("return", _context.t0);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.setUniverse = setUniverse;